module.exports = __webpack_public_path__ + "img/icon-banner-dex-safe-dark.df61771d.svg";